
import { PropType, defineComponent, ref, computed } from "vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLockOpenVariant, mdiLock } from '@mdi/js';

import PaginationType from "@/types/Pagination";
import Order from "@/types/Order";
import Pagination from "../General/Pagination.vue";
import { debounce } from "lodash";
import { Link} from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import Card from "../General/Card.vue";
import route from "ziggy-js";
import { Inertia } from "@inertiajs/inertia";
import { useStore } from "@/stores/main";


export default defineComponent({
  props: {
    type: {
      type: String,
    },
    orders: {
      type: Object as PropType<PaginationType<Order>>,
    },
  },
  setup(props) {
    const store = useStore();
    store.setUpStore();

    const isAdmin = computed(() => store.isAdmin)

    const paginationSize = ref();

    const checkSize = (event?: Event) => {
      paginationSize.value = "sm";
      console.log(window.innerWidth);

      if (window.innerWidth > 768) {
        paginationSize.value = "md";
      }

      if (window.innerWidth > 1080) {
        paginationSize.value = "lg";
      }
    };

    window.addEventListener("resize", debounce(checkSize, 250));

    checkSize();

    const addLineBreaks = (comment: string) => {
      const breakTag = "<br>";

      return (comment + "").replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        "$1" + breakTag + "$2"
      );
    };

    const lockOrder = (orderId:any) =>{
      Inertia.visit(route("orders.lock", {order:orderId}),
      { method: 'post' , only: ['orders']}as any)
    }

    const unlockOrder = (orderId:any) =>{
      Inertia.visit(route("orders.unlock", {order:orderId}),
      { method: 'post', only: ['orders'] } as any)
    }

    return {
      paginationSize,
      route,
      dayjs,
      addLineBreaks,
      mdiLock,
      mdiLockOpenVariant,
      lockOrder,
      unlockOrder,
      isAdmin
    };
  },
  components: { Button, SvgIcon, Pagination, Link, Card },
});
